import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Papa from "papaparse";
import axios from 'axios';
import { format, parse, isValid } from 'date-fns';
import "./Subir-contactos.css";
import { useRol } from "../../Context";
import { PageBase } from "../../Components/PageBase";
import nube from "../../icons/upload.png";
import carpeta from "../../icons/archivos.png";
import iconCSV from "../../icons/csv.svg";
import circleClose from "../../icons/icons8-macos-close-32.png";
import circleCloud from "../../icons/ios-cloud-done.svg";

const API_ENDPOINT = '/api/app/leads';

function SubirContactos() {
    const fileInputRef = useRef(null);
    const navigate = useNavigate()
    const { setLeads, vacantCode, Id } = useRol();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [porcentajes, setPorcentajes] = useState([]);
    const [failedLeads, setFailedLeads] = useState([]);
    const [contactos, setContactos] = useState([])
    const [error, setError] = useState(false);
    const [cargando, setCargando] = useState(false)
    const [message, setMessage] = useState('Cargados correctamente');
    const [errorMessage, setErrorMessage] = useState('');

    const convertirFormatoFecha = (fechaString) => {
        // Parsea la fecha en formato "DD/MM/YYYY"
        const fechaParseada = parse(fechaString, 'dd/MM/yyyy', new Date());

        // Verifica si la fecha es válida
        if (isValid(fechaParseada)) {
            // Formatea la fecha en el formato deseado "yyyy-MM-dd'T'HH:mm:ssXXX"
            const fechaFormateada = format(fechaParseada, "yyyy-MM-dd'T'00:00:00XXX", { timeZone: '-06:00' });
            return fechaFormateada;
        } else {
            return 'Fecha no válida';
        }
    };

    const handleFileChange = async (event) => {
        try {
            setCargando(true);
            const files = event.target.files;

            for (let i = 0; i < files.length; i++) {
                const file = files[i];

                if (file.name.toLowerCase().endsWith('.csv')) {
                    try {
                        const csvData = await new Promise((resolve, reject) => {
                            const reader = new FileReader();

                            reader.onload = (e) => {
                                const result = e.target.result;
                                resolve(result);
                            };

                            reader.onerror = (error) => reject(error);

                            reader.readAsText(file);
                        });

                        // Pasa el archivo actual al proceso de datos CSV
                        setCargando(false);
                        setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, file]);
                        await processCSVData(Papa.parse(csvData, { header: true }).data, file);
                    } catch (error) {
                        setError(true);
                        console.error('Error al procesar el archivo CSV:', error);
                        setErrorMessage(`Error al procesar el archivo CSV: ${file.name}`);
                    }
                } else {
                    setError(true);
                    setErrorMessage(`El archivo ${file.name} no es un archivo CSV válido`);
                }
            }


        } catch (error) {
            setError(true);
            console.error('Error al manejar el cambio de archivo:', error);
            setErrorMessage('Error al manejar el cambio de archivo');
            setCargando(false);
        }
    };

    const processCSVData = async (csvData, currentFile) => {
        try {
            const newLeads = [];
            const totalLeads = csvData.length;
            let completedLeads = 0;

            setContactos(totalLeads);

            await Promise.all(
                csvData.map(async (row) => {
                    if (row.email) {
                        const lead = {
                            "vacant_code": vacantCode,
                            "initial_comment": "Contacto subido por transfer",
                            "candidate_name": row.contact_name,
                            "email": row.email,
                            "phone_number": row.phone,
                            "city": row.address,
                            "budget": row.budget,
                            "payment_type": row.payment_method,
                            "origin": row.origin,
                            "created_date": convertirFormatoFecha(row.created_date),
                            "postulation_date": convertirFormatoFecha(row.postulation_date),
                            "purchase_reason": row.purchase_reason,
                            "purchase_time": row.purchase_time,
                            "contact_type": row.contact_type,
                            "recruiter_name": row.recruiter,
                            "interest": 50,
                            "recruiter": Id,
                            "gender": "No definido"
                        };

                        try {
                            const response = await axios.post(API_ENDPOINT, lead, {
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                            });

                            newLeads.push(response.data);
                            completedLeads++;

                            // Actualizar porcentaje de carga
                            const progressPercentage = Math.floor((completedLeads / totalLeads) * 100);
                            setPorcentajes(prevPorcentajes => {
                                const nuevosValores = [...prevPorcentajes];
                                nuevosValores[prevPorcentajes.length - 1] = progressPercentage;
                                return nuevosValores;
                            });
                        } catch (error) {
                            setError(true);
                            console.error('Error al subir el lead:', error);
                            setErrorMessage(`Error al subir el lead ${row.contact_name} del archivo ${currentFile.name}`);
                            completedLeads++; // Incrementar aunque haya fallado para mantener el porcentaje correcto
                            setFailedLeads((prevFailedLeads) => [
                                ...prevFailedLeads,
                                {
                                    leadData: lead,
                                    errorMessage: 'Error al subir el lead ' + row.contact_name,
                                    file: currentFile.name
                                },
                            ]);
                        }
                    }
                })
            );

            // Actualizar porcentaje al 100% cuando todas las peticiones hayan terminado
            setPorcentajes(prevPorcentajes => {
                const nuevosValores = [...prevPorcentajes];
                nuevosValores[prevPorcentajes.length - 1] = 100;
                return nuevosValores;
            });

            if (newLeads.length > 0) {
                setError(false);
                setMessage('Cargados correctamente');
            } else {
                setError(true);
                setErrorMessage('Error al subir los leads');
            }

            setLeads((prevLeads) => [...prevLeads, ...newLeads]);
        } catch (error) {
            setError(true);
            console.error('Error al procesar CSV:', error);
            setErrorMessage('Error al procesar CSV');
        }
    };


    const handleDeleteFile = (index) => {
        const updatedSelectedFiles = [...selectedFiles];
        updatedSelectedFiles.splice(index, 1);
        setSelectedFiles(updatedSelectedFiles);
    };

    const descargarCSV = () => {
        const csvContent = 'contact_name,phone,address,email,purchase_reason,purchase_time,payment_method,budget,contact_type,origin,recruiter,postulation_date,created_date,initial_comment\nJosiah B. Olsen,4445356330,Cuernavaca,imperdiet.erat@icloud.edu,Vivir,"Tres meses,",Contado,757742,Teléfono,Whatsapp,Cullen,17/02/2024,23/05/2023,CASA NOVA - van a verificar su cuenta infonavit.\nRussell M. Warner,4443948911,Tonalá,est.vitae@google.couk,Inversión,"Seis meses,",Credito,600360,Correo,Instagram,Sebastian,11/08/2024,31/01/2023,CASA NOVA - van a verificar su cuenta fovisste.';
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'uploads.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        let intervalos = [];

        if (selectedFiles && selectedFiles.length > 0) {
            const nuevosPorcentajes = porcentajes.length === 0 ? selectedFiles.map(() => 0) : porcentajes;
            setPorcentajes(nuevosPorcentajes);

            intervalos = selectedFiles.map((file, index) =>
                setInterval(() => {
                    if (porcentajes[index] < 100) {
                        setPorcentajes(prevPorcentajes => {
                            const nuevosValores = [...prevPorcentajes];
                            nuevosValores[index] = nuevosValores[index] + 1;
                            return nuevosValores;
                        });
                    }
                }, 300)
            );
        }

        return () => intervalos.forEach(clearInterval);
    }, [selectedFiles, porcentajes]);

    const viewCloud = () => {
        navigate('/Contactos')
    }

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="subir-contactos-web">
                    <div className="card-subirContactos">
                        Carga tus archivos
                        <div className="drop-area">
                            <img src={nube} alt="nube" />
                            <label>Añade aquí tus documentos CSV</label>
                            <input
                                type="file"
                                style={{ display: 'none' }}
                                onChange={(event) => handleFileChange(event)}
                                ref={fileInputRef}
                                accept=".csv"
                                multiple
                            />
                            <button onClick={() => fileInputRef.current.click()}>Cargar archivos</button>
                        </div>
                        <label className="tranfer-ejemlo-link" onClick={descargarCSV}> <img src={iconCSV} alt="" /> Ejemplo de formato .CSV</label>
                    </div>
                    <div className="archivos-cargados">
                        <div>Archivos cargados</div>
                        {/* Mostrar carga si está en progreso */}
                        {cargando && (
                            <div className="carga-files">
                                <p>Cargando...</p>
                                <div className="loadingio-spinner-magnify-e8d28hsw2v4">
                                    <div className="ldio-h1vfz5taivh">
                                        <div><div><div></div><div></div></div></div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* Mostrar archivos seleccionados si existen */}
                        {selectedFiles?.length > 0 && !cargando && (
                            selectedFiles.map((file, index) => (
                                <div className="card-files" key={index}>
                                    <div className="file-container">
                                        <img src={iconCSV} alt="" />
                                        <p>{file.lastModified}{'_'}{file.name}</p>
                                        {/* Mostrar barra de progreso si no está completado */}
                                        {porcentajes[index] < 100 && !error && (
                                            <span id="progress">
                                                {porcentajes[index]}%
                                                {/* Agregar indicador de carga */}
                                                <div className="loadingio-spinner-bars-ig6vz7wuzi">
                                                    <div className="ldio-ge11hcq70zm">
                                                        <div></div><div></div><div></div><div></div>
                                                    </div>
                                                </div>
                                            </span>
                                        )}
                                        {/* Mostrar mensaje de error si hay un error */}
                                        {error[index] && <span id="error">{errorMessage}</span>}
                                        {/* Mostrar mensaje completado si está al 100% */}
                                        {porcentajes[index] === 100 && !error && <span id="completed">{contactos - (failedLeads.length + 1)} {message}</span>}
                                        {/* Botón para eliminar el archivo */}
                                        {porcentajes[index] < 100 || (error && <button onClick={() => handleDeleteFile(index)}>
                                            <img src={circleClose} alt="" />
                                        </button>)}
                                        {porcentajes[index] === 100 && !error && <button onClick={() => viewCloud()}>
                                            <img src={circleCloud} alt="" />
                                        </button>}
                                    </div>
                                    {failedLeads?.length > 0 && (
                                        <ul>
                                            {failedLeads
                                                .filter(lead => lead.file === file.name)
                                                .map((lead, index) => (
                                                    <li id="error" key={index}>{index + 1}.- {lead.leadData.contact_name} {lead.errorMessage}</li>
                                                ))}
                                            <li id="download">Descargar CSV de los contactos faltantes</li>
                                        </ul>
                                    )}
                                </div>
                            ))
                        )}
                        {/* Mostrar mensaje si no hay archivos seleccionados */}
                        {selectedFiles?.length === 0 && !cargando && (
                            <div>
                                <img src={carpeta} alt="carpeta" />
                                <br />
                                <label>Aún no has añadido archivos</label>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export { SubirContactos };